import { EngineStoreData } from "@/stores/EngineStore/EngineStore.ts";

export const setAdultsAgeHelper = (state: EngineStoreData, id: string, age: number, itemId: string) => ({
  cartAccommodationItems: state.cartAccommodationItems?.map((CAI) => {
    if (CAI.id === itemId) {
      return { ...CAI, adults: CAI.adults?.map((adult) => (adult.id === id ? { ...adult, age } : adult)) };
    }
    return CAI;
  }),
});
